import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row } from 'react-bootstrap';
import MediaGalleryImage from '../../../../../modules/react/components/stateful/MediaGalleryImage';
import styles from './styles.scss';

const propTypes = {
  featuredImage: PropTypes.string,
  medium: PropTypes.object,
  children: PropTypes.element.isRequired,
};

const defaultProps = {
  featuredImage: undefined,
  medium: undefined,
};

const Template = ({ featuredImage, medium, children }) => {
  let mediumFilename;
  if (featuredImage) {
    const filenameIdx = featuredImage.indexOf('/');
    mediumFilename = featuredImage.slice(filenameIdx + 1);
  }

  return (
    <div className={styles.popupBody}>
      <Container fluid>
        {(featuredImage || medium)
          && (
            <Row>
              <div className={styles.featuredImage}>
                <MediaGalleryImage
                  legacyImage={{ file: featuredImage }}
                  medium={medium}
                  mediumFilename={mediumFilename}
                />
              </div>
            </Row>
          )
        }
        {children}
      </Container>
    </div>
  );
};

Template.propTypes = propTypes;
Template.defaultProps = defaultProps;

export default Template;
